<template>
  <div class="content">
    <div class="btn btnL" @click="toLeft" ref="btnL">
      <img src="../assets/imgs/左箭头.png" alt />
    </div>
    <div class="lunbo">
      <div class="imgList" ref="lunbo">
        <a
          v-for="(item, index) in lunboList"
          :key="index"
          :href="item.href"
          target="_blank"
        >
          <img :src="item.src" />
        </a>
      </div>
    </div>
    <div class="btn" @click="toRight" ref="btnR">
      <img src="../assets/imgs/右箭头.png" alt />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lunboList: [
        {
          src: require('../assets/imgs/阳光决策.png'),
          href:
            'http://1.192.106.56:10011?redirect=/index&ssoUrl=http://117.159.15.238:16003',
        },
        {
          src: require('../assets/imgs/网报支付.png'),
          href: 'http://117.159.15.238:10102', //银农直联
        },
        {
          src: require('../assets/imgs/产权交易.png'),
          href: 'https://hlq.hncqjy.com/',
        },
        {
          src: require('../assets/imgs/三资台账.png'),
          href: 'http://117.159.15.238:16003/', //
        },

        {
          src: require('../assets/imgs/阳光公开.png'),
          href: 'http://117.159.15.238:16005/', //
        },
        {
          src: require('../assets/imgs/部门管理.png'),
          href: 'http://117.159.15.238:16028/login',
        },
        {
          src: require('../assets/imgs/三资备查.png'),
          href: 'http://117.159.15.238:8086/hlq_sz/login_form.jsp', //
        },
        {
          src: require('../assets/imgs/农业大数据中心.png'),
          href: 'http://117.159.15.203:10109/',
        },
        // {
        //   src: require("../assets/imgs/财务管理.png"),
        //   href: "http://180.76.150.77:8086/hlq_cw/login_form.jsp",//
        // },

        // {
        //   src: require("../assets/imgs/清产核资.png"),
        //   href: "http://117.159.15.203:896/acvs/main/toLogin",
        // },
        // {
        //   src: require("../assets/imgs/股权管理.png"),
        //   href: "http://117.159.15.203:10012/guquan",//
        // },

        //   {
        //     src: require("../assets/imgs/产权交易.png"),
        //     href: "http://117.159.15.203:10124/",
        //   },

        // {
        //   src: require("../assets/imgs/新型经营主体.png"),
        //   href: "http://117.159.15.203:10102/",//
        // },

        // {
        //   src: require("../assets/imgs/土地确权.png"),
        //   href: "http://106.13.144.13:8078",
        // },
        // -----------------------------

        //   {
        //     src: require("../assets/imgs/合同管理.png"),
        //     href: "http://106.13.144.13:8075/trKAqlnjxZ.php/index/login",
        //   },

        // {
        //   src: require("../assets/imgs/两区划定.png"),
        //   href: "http://106.13.144.13:8077",
        // },

        // {
        //   src: require("../assets/imgs/土地抵押.png"),
        //   href: "http://106.13.110.177:8014/",
        // },
      ],
      idx: 0,
    }
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    // 向右
    toRight() {
      this.$refs.btnL.style.cursor = 'pointer'

      if (this.idx > -3) {
        this.idx--
        if (this.idx == -3) {
          this.$refs.btnR.style.cursor = 'not-allowed'
        }

        this.$refs.lunbo.style.left =
          +this.$refs.lunbo.style.left.slice(0, -2) - 270 + 'px'
      }
    },

    // 向左
    toLeft() {
      this.$refs.btnR.style.cursor = 'pointer'
      if (this.idx < 0) {
        this.idx++
        if (this.idx == 0) {
          this.$refs.btnL.style.cursor = 'not-allowed'
        }
        this.$refs.lunbo.style.left =
          +this.$refs.lunbo.style.left.slice(0, -2) + 270 + 'px'
      }
    },
  },
}
</script>

<style scoped>
.content {
  width: 1450px;
  height: auto;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  /* padding-top: 36%; */
  padding-top: 35%;
}
@media screen and (min-height: 1000px) {
  .content {
    padding-top: 38%;
  }
}

.btn {
  width: 50px;
  height: 50px;
  cursor: pointer;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  background-color: #9796967f;
  border-radius: 50%;
}

.btnL {
  cursor: not-allowed;
}

.btn > img {
  display: block;
  /* margin-top: 30px; */
  width: 19px;
  height: 34px;
}

.lunbo {
  width: 1330px;
  /* width: 100%; */
  /* height: 130px; */
  height: 195px;
  overflow: hidden;
  position: relative;
}

.imgList {
  position: absolute;
  width: 2140px;
  /* width: 100%; */
  /* height: 130px; */
  height: 195px;
  left: 0px;
  top: 0px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  transition: all 0.5s linear;
  margin: 0 auto;
}

.imgList a {
  display: block;
  /* width: 200px;
    height: 130px; */
  width: 250px;
  height: 170px;
  cursor: pointer;
  /* border-radius: 10px; */
  border-radius: 20px;
  overflow: hidden;
}

.imgList a img {
  display: block;
  width: 100%;
  height: 100%;
  background-color: rgb(177, 180, 180);
  cursor: pointer;
  border: none;
}
</style>
